import { createContext } from 'react';

import { Size } from '../../types';

export type RadioGroupStyle = {
  size?: Size;
  variant?: 'solid' | 'soft' | 'outline';
  /** The group's resolved read-only state, which styles every child alike. */
  isReadOnly?: boolean;
  /** Set by the group, so a child knows the group owns its label and required mark. */
  inGroup?: boolean;
};

/**
 * The state a RadioGroup passes down to its child Radios. Internal (not
 * exported from the lib): a child's own props always win over the group's.
 */
export const RadioGroupStyleContext = createContext<RadioGroupStyle>({});
